import React, { FC } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { buildHighlightParts } from 'utils/knowledgeBaseSearch'

interface IHighlightedText {
  text: string
  search: string
}

const useStyles = makeStyles((theme) => ({
  mark: {
    backgroundColor: theme.palette.warning.light,
    color: 'inherit',
    fontWeight: 600,
    borderRadius: '2px',
  },
}))

const HighlightedText: FC<IHighlightedText> = ({ text, search }) => {
  const s = useStyles()
  const parts = buildHighlightParts(text, search)

  return (
    <>
      {parts.map((part) => (
        <React.Fragment key={part.start}>
          {part.isMatch ? <mark className={s.mark}>{part.text}</mark> : part.text}
        </React.Fragment>
      ))}
    </>
  )
}

export default HighlightedText
